/**
 * TawkToWidget — iter640 / iter698 (feature-gated)
 *
 * Tawk.to live chat widget. Loads the Tawk.to embed script ONLY when valid
 * REACT_APP_TAWK_PROPERTY_ID and REACT_APP_TAWK_WIDGET_ID env vars are set.
 *
 * iter698 — Removed the hard-coded placeholder IDs that 404'd in production
 * and polluted the console with a CORS error on every page load. If you want
 * the chat widget back, set the env vars to real Tawk.to property/widget IDs.
 */
import { useEffect } from "react";

const PROPERTY_ID = process.env.REACT_APP_TAWK_PROPERTY_ID;
const WIDGET_ID   = process.env.REACT_APP_TAWK_WIDGET_ID;

export default function TawkToWidget() {
  useEffect(() => {
    // Feature-gate: bail out if env vars are not configured.
    if (!PROPERTY_ID || !WIDGET_ID) return;
    // Avoid double-injecting if React strict-mode re-mounts in dev.
    if (window.Tawk_API || document.getElementById("tawk-to-script")) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s = document.createElement("script");
    s.id = "tawk-to-script";
    s.async = true;
    s.src = `https://embed.tawk.to/${PROPERTY_ID}/${WIDGET_ID}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.body.appendChild(s);
  }, []);

  return null;
}
